angular.module("vgresiduos").directive("vertownNotificationsManager", function () {
	"use strict";
	return {
		scope: true,
		controller: "vertownNotificationsManagerCtrl",
		controllerAs: "ctrl",
		templateUrl:
			"views/components/vertownNotifications/vertownNotificationsManager/vertownNotificationsManager_template.html"
	};
});
